import TemplateView from '../../TemplateView'
import WorkflowStatusList from './WorkflowStatusList'
import WorkflowStatusNode from './WorkflowStatusNode'
import WorkflowStatusTypeNode from './WorkflowStatusTypeNode'
import ScrollableContainer from '../../util/ScrollableContainer'
import {connect} from '../../redux/utils'
import {WorkflowStatusType} from '../constants'
import {getWorkflowStatuses} from '../../entities/selectors'

export class WorkflowStatusSelector extends TemplateView {
    constructor({
                    onSelectStatus = (id) => {},
                    typeFilter = null,
                    groupByStatusType = true,
                    showActionNames = false,
                }) {
        super(null)

        this.state = {
            statusesMap: {},
            selectedStatusId: -1,
            inactiveOpenStatuses: false,

            showCompletedFirst: false,
            showReopenLabel: false,
        }

        this.params = {
            onSelectStatus,
            typeFilter,
            groupByStatusType,
            showActionNames,
        }

        this.onAnyStatePropertyDeeplyChanged(['statusesMap', 'selectedStatusId', 'inactiveOpenStatuses', 'showCompletedFirst', 'showReopenLabel'], () => {
            if (this.rendered) {
                this._renderList()
            }
        })
    }

    templateHtml() {
        return '<div class="workflowStatus_components_workflowStatusSelector"></div>'
    }

    afterRender() {
        this._renderList()
    }

    update() {
        super.update()
        if (!!this.scrollableContainer)
            this.scrollableContainer.forceUpdate()
    }

    _renderList() {
        this.$el.empty()
        this.scrollableContainer = new ScrollableContainer(
            null,
            new WorkflowStatusList({
                groupRenderer: ($el, type) => {
                    new WorkflowStatusTypeNode(type).init($el)
                },
                statusRenderer: ($el, status) => {
                    new WorkflowStatusNode({
                            status,
                            checked: this.state.selectedStatusId === status.id
                        },
                        this._handleOnClickStatus
                    ).init($el)
                },
                showGroups: this.params.groupByStatusType
            })
        )

        const completedSelected = !!this.state.statusesMap[this.state.selectedStatusId] &&
                                   this.state.statusesMap[this.state.selectedStatusId].type === WorkflowStatusType.COMPLETED
        const statusesList = this._getStatusesList()
        const numOfCompleted = statusesList.reduce((acc, val) => acc + (val.type === WorkflowStatusType.COMPLETED ? 1 : 0), 0)
        const hideCompleted = this.state.showCompletedFirst && completedSelected && numOfCompleted <= 1
        this.scrollableContainer.init(this.$el).setState({
            statuses: statusesList,
            inactiveOpenStatuses: this.state.inactiveOpenStatuses,
            showGroups: this.params.groupByStatusType && (!this.state.showReopenLabel || !this.params.showActionNames),
            hideCompleted: hideCompleted,
            showCompletedFirst: this.state.showCompletedFirst,
            showReopenLabel: this.params.showActionNames && this.state.showReopenLabel,
            showChangeStatusLabel: !hideCompleted && this.params.showActionNames,
        })
    }

    _getStatusesList() {
        const statusesList = Object.values(this.state.statusesMap)
        if (this.params.typeFilter === null) {
            return statusesList
        }

        return statusesList.filter((st) => {
            return st.type === this.params.typeFilter
        })
    }

    _handleOnClickStatus = (id) => {
        this.params.onSelectStatus(id)
    }
}

export default connect(
    (state) => ({
            statusesMap: getWorkflowStatuses(state)
    })
)(WorkflowStatusSelector)



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/WorkflowStatusSelector.js